export const MAX_ITEMS = 16;
export const MIN_ITEMS = 4;
export const MAX_ITEMS_PER_ROW = 8;
export const MIN_SHOW_MAX = 4;
